import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import leftIcon from '../static/ic_quote_left.svg'
//import leftIcon from '../static/rectangle1.png'

const HomeSlides = styled(Slider)`
  width: 100%;
  padding-top: 70px;
  display: flex !important;
  & > button:first-child {
    display: none !important;
  }
  & > button:nth-child(3) {
    display: none !important;
  }
  & > div:nth-child(2) {
    & > div {
      & > div {
        & > div {
          & > div {
            display: flex !important;
            flex-direction: column;
            align-items: center;
          }
        }
      }
    }
  }
  .slick-slide.slick-active.slick-current {
    margin-right: 150px;
  }
`
// const Slides = styled(Slider)`
//   width: 100%;
//   padding-top: 70px;
//   display: flex !important;
//   & > button:first-child {
//     display: none !important;
//   }
//   & > button:nth-child(3) {
//     display: none !important;
//   }

//   & > div:nth-child(2) {
//     & > div {
//       & > div {
//         & > div {
//           & > div {
//             display: flex !important;
//             flex-direction: column;
//             align-items: center;
//           }
//         }
//       }
//     }
//   }
// `
const CenterModeSlides = styled(Slider)`
  width: 100%;
  padding-top: 70px;
  display: flex !important;
  & > button:first-child {
    display: none !important;
  }
  & > button:nth-child(3) {
    display: none !important;
  }
  & > div:nth-child(2) {
    & > div {
      & > div {
        & > div {
          & > div {
            display: flex !important;
            flex-direction: column;
            align-items: center;
          }
        }
      }
    }
  }
  .slick-dots {
    bottom: -50px;
  }
  .slick-slide.slick-active.slick-center.slick-current {
    & img {
      min-height: 100%;
      box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.3);
    }
  }
`
const ClientSlides = styled(Slider)`
  width: 100%;
  padding-top: 50px;
  padding-bottom: 30px;
  display: flex !important;
  @media (max-width: 640px) {
    padding-top: 0;
  }
  & > button:first-child {
    display: none !important;
  }
  & > button:nth-child(3) {
    display: none !important;
  }
  .slick-list {
    border: none;
  }
  & p {
    position: relative;
    max-width: 850px;
    word-break: break-word;
    padding: 40px 20px 30px;
    font-size: 20px;
    font-weight: normal;
    line-height: 1.8;
    text-align: center;
    color: #333333;
    @media (max-width: 640px) {
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 20px;
    }
  }
  & h3 {
    color: #333333;
    line-height: 1.52;
    font-size: 22px;
    font-weight: 600;
  }
  & > div:nth-child(2) {
    & > div {
      & > div {
        & > div {
          & > div {
            display: flex !important;
            flex-direction: column;
            align-items: center;
            &:focus {
              box-shadow: none;
              outline: none;
            }
          }
        }
      }
    }
  }

  @media (max-width: 992px) {
    & p {
      font-size: 18px;
    }
    & h3 {
      font-size: 20px;
    }
    & div {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    & p {
      font-size: 16px;
    }
  }
`
const StyledUl = styled.ul`
  & > li {
    width: 30px;
    height: 2px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
    background: #000;
    opacity: 0.2;
    & > button {
      /*   width: 30px;
      height: 2px;
      background: red; */
    }
    & > button:before {
      content: '';
    }
  }
  & > li.slick-active {
    background: #333333;
    opacity: 1;
  }
`

const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const CarouselImagesContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
const CarouselImage = styled.img`
  max-width: 100%;
  height: 200px;
  object-fit: contain;
  padding: 0 30px 30px 0;
`
const Div = styled.div`
  position: relative;
  & > img {
    width: 300px;
    // height: 240px;
    object-fit: contain;
  }
  & h3 {
    position: absolute;
    bottom: 10px;
    line-height: 1.64;
    letter-spacing: 1.4px;
    color: rgba(255, 255, 255, 0.8);
  }
  & > p {
    position: absolute;
    bottom: 40px;
    font-size: 18px;
    font-weight: 300;
    line-height: normal;
    color: #ffffff;
  }
`
const StyledIcon = styled.img`
  position: relative;
  width: 20px;
`

export class CarouselComponent extends Component {
  render() {
    const { carouselType = 'home' } = this.props

    const settings = {
      className: 'slider variable-width',
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ],
      appendDots: dots => (
        <div>
          <StyledUl style={{ margin: '0px', padding: '0px' }}> {dots} </StyledUl>
        </div>
      )
    }
    const clientSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      appendDots: dots => (
        <div>
          <StyledUl style={{ margin: '0px', padding: '0px' }}> {dots} </StyledUl>
        </div>
      )
    }
    const centerMode = {
      dots: true,
      className: 'center',
      centerMode: true,
      infinite: true,
      autoplay: false,
      centerPadding: '10px',
      slidesToShow: 3,
      speed: 500,
      appendDots: dots => (
        <div>
          <StyledUl style={{ margin: '0px', padding: '0px' }}> {dots} </StyledUl>
        </div>
      )
    }
    return (
      <Fragment>
        {carouselType === 'clients' ? (
          <ClientSlides {...clientSettings}>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                When it comes to digital marketing there are loads commentators that talk a good game, but 8om helps you
                make it happen. We knew we wanted someone who could understand the audience we are catering to and at
                the same time understand what we have to offer them and thus act as a bridge in communicating the same.
              </p>
              <h3>Kawaljeet Kaur</h3>
              <div>Content Strategist</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                8om took the time to really understand our business model and market to strategically direct us on
                everything from design to creating the right content. It is not about being just a service provider,
                instead it is about forming a sustainable and long-lasting relationship. They have put in a phenomenal
                effort in tandem with our team to get the job done, be it creative designing or website development.
                There offering has been at par with the market standards and 8om always believes in providing their
                customer with a beautiful experience.
              </p>
              <h3>Mukund</h3>
              <div>CEO - Tanoshii Trail</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                They have provided us with some really good resources, the creative designers have thoroughly understood
                our idea and have made it much easier for us to strategize things. A brief of the idea is all they
                require and the job is done right. The solutions have always been very thoughtful and have helped us in
                the different spheres of our offerings. The technical assistance has been a great reward for our company
                as we were able to understand a lot of things.
              </p>
              <h3>Achintaya</h3>
              <div>Marketing Head</div>
            </div>
          </ClientSlides>
        ) : carouselType === 'books' ? (
          <ClientSlides {...clientSettings}>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                Books best serve to confused clients and beginners having no accounting background. We love Book’s clean
                interface and that it has just the right amount of customization available. I’ve had great experience
                with their support and I recommend it to anyone considering their options.
              </p>
              <h3>Anand Mishra</h3>
              <div>Accountant</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                Books for us means a significant reduction in administrative overhead and human error, leading to higher
                productivity and scalability.
              </p>
              <h3>Gaurav Ahuja</h3>
              <div>Accountant</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                As an accountant myself, I love it’s simplicity and user friendliness. It blends well within our
                Educational Organisation set-up and it meets all our bookkeeping needs, from keeping student records, to
                issuing of invoices, etc.
              </p>
              <h3>Rajesh Sharma</h3>
              <div>Accountant</div>
            </div>
          </ClientSlides>
        ) : carouselType === 'trckr' ? (
          <ClientSlides {...clientSettings}>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                Easy-to-navigate process menus. Familiar user interface (UI) for users. Huge user community. Excellent
                import capabilities. Excellent integration with Sales and Purchasing.
              </p>
              <h3>Mukul</h3>
              <div>Manufacturer</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                Excellent transaction drill down. Powerful audit trail report capability. Extensive online training and
                help functionality. Extensive report export options.
              </p>
              <h3>Mahinder Singh</h3>
              <div>Businessman</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                Trckr does exactly what it is supposed to do and it is very intuitive and easy to use. I just love the
                software and I love the team of people who support it.
              </p>
              <h3>Jayshree Singh</h3>
              <div>Product Manager</div>
            </div>
          </ClientSlides>
        ) : carouselType === 'home' ? (
          <Fragment>
            <HomeSlides {...settings}>
              <ContainerWrapper>
                <CarouselImagesContainer>
                  <CarouselImage src={require('../static/work1.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work2.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work3.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work4.png')} alt="carousel" />
                </CarouselImagesContainer>
                <CarouselImagesContainer>
                  <CarouselImage src={require('../static/work5.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work6.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work7.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work8.png')} alt="carousel" />
                </CarouselImagesContainer>
              </ContainerWrapper>
              <ContainerWrapper>
                <CarouselImagesContainer>
                  <CarouselImage src={require('../static/work1.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work2.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work3.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work4.png')} alt="carousel" />
                </CarouselImagesContainer>
                <CarouselImagesContainer>
                  <CarouselImage src={require('../static/work5.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work6.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work7.png')} alt="carousel" />
                  <CarouselImage src={require('../static/work8.png')} alt="carousel" />
                </CarouselImagesContainer>
              </ContainerWrapper>
            </HomeSlides>
          </Fragment>
        ) : carouselType === 'extract' ? (
          <ClientSlides {...clientSettings}>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                The software is really great. if you are a beginner in scraping and web crawling, this is the tool that
                will convert you from Zero to Hero in scraping and crawling. great for beginners and experts.
              </p>
              <h3>Sandeep Gupta</h3>
              <div>Software Developer</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />I am not a developer but their interface, tutorials and customer
                service made it pretty intuitive. The price was reasonable and I had a lot of other work to do, so it
                was a win-win.
              </p>
              <h3>Tushar Mittal</h3>
              <div>Student</div>
            </div>
            <div>
              {/*<img src={require('../static/ic_compass.svg')} alt="compass" />*/}
              <p>
                <StyledIcon alt="icon" src={leftIcon} />
                Love how easy it is to get started and how it’s connected to an API out of the box. It’s as easy as
                click and accept.
              </p>
              <h3>Nakul Arya</h3>
              <div>Python Developer</div>
            </div>
          </ClientSlides>
        ) : (
          <Fragment>
            <CenterModeSlides {...centerMode}>
              <Div>
                <img src={require('../static/work1.png')} alt="compass" />
                <p>24 Jun 2018</p>
                <h3>Lovers The Moonlight Cocktail</h3>
              </Div>
              <Div>
                <img src={require('../static/work1.png')} alt="compass" />
                <p>24 Jun 2018</p>
                <h3>Lovers The Moonlight Cocktail</h3>
              </Div>
              <Div>
                <img src={require('../static/work1.png')} alt="compass" />
                <p>24 Jun 2018</p>
                <h3>Lovers The Moonlight Cocktail</h3>
              </Div>
              <Div>
                <img src={require('../static/work1.png')} alt="compass" />
                <p>24 Jun 2018</p>
                <h3>Lovers The Moonlight Cocktail</h3>
              </Div>
              <Div>
                <img src={require('../static/work1.png')} alt="compass" />
                <p>24 Jun 2018</p>
                <h3>Lovers The Moonlight Cocktail</h3>
              </Div>
            </CenterModeSlides>
          </Fragment>
        )}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CarouselComponent.js